import {
  PriceDtoCurrencyEnum,
  ProductControllerSearchV2GendersEnum,
  ProductControllerSearchV2SourcesEnum,
} from "definitions/product-storage";
import type { FieldPath } from "react-hook-form";
import { generateSizeRange } from "src/util";

import type { ProductFilters } from "./ProductFilters";

export const sizeList = generateSizeRange(36, 50).map((value) => ({
  label: String(value),
  value: String(value),
}));

export const sourcesList = Object.entries(
  ProductControllerSearchV2SourcesEnum,
).map(([key, value]) => ({
  label: key.toUpperCase(),
  value: value,
}));

const gendersMap = {
  [ProductControllerSearchV2GendersEnum.Male]: "Мужской",
  [ProductControllerSearchV2GendersEnum.Female]: "Женский",
  [ProductControllerSearchV2GendersEnum.Unisex]: "Унисекс",
  [ProductControllerSearchV2GendersEnum.Child]: "Ребенок",
  [ProductControllerSearchV2GendersEnum.Baby]: "Малыш",
  [ProductControllerSearchV2GendersEnum.MiddleChild]: "Средний ребенок",
  [ProductControllerSearchV2GendersEnum.EldestChild]: "Старший ребенок",
};

export const gendersList = Object.values(
  ProductControllerSearchV2GendersEnum,
).map((value) => ({
  label: gendersMap[value],
  value: value,
}));

export const includeCustomOptions = [
  {
    label: "Все товары",
    value: undefined,
  },
  {
    label: "Только кастомные",
    value: true,
  },
  {
    label: "Без кастомных",
    value: false,
  },
];

export const FIELDS_APPLIED_ON_BLUR = new Set<FieldPath<ProductFilters>>([
  "priceFrom",
  "priceTo",
  "createdFrom",
  "createdTo",
]);

export const currencyOptions = Object.entries(PriceDtoCurrencyEnum).map(
  ([key, value]) => ({
    label: key.toUpperCase(),
    value: value,
  }),
);
